/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 7/20/20
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';

import PrivateRoute from './PrivateRoute';
import { selectAuthUserTokenIsSet } from 'selectors/entities/users';

const mapStateToProps = state => ({
  isAuthenticated: selectAuthUserTokenIsSet(state),
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./js/components/support/routing/PrivateRoute/index.js